import React, { FC, useState } from "react";
import BNewPagination from "../../components/b-pagination_new";
import TransactionPrivateTagModal from "./utils/TransactionPrivateTagModal";
import TransactionPrivateTags from "./utils/TransactionPrivateTags";
import EmailAccessWrapper from "../../components/EmailAccessWrapper";
import { useSelector } from "react-redux";

const TxPrivateTags: FC = () => {
  const [pagination, setPagination] = useState<any>({
    limit: 50,
    page: 1,
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const [refreshList, setRefreshList] = useState(0);
  const handleTagCreated = () => {
    closeModal();
    setRefreshList((prev) => prev + 1);
  };
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const _account = useSelector((e: Object) => (e as any)?.common?.account);

  return (
    <EmailAccessWrapper
      onVerifyClick={() => setShowVerificationModal(true)}
      showVerifyButton={!!_account?.email}
    >
      <div className="bs-card mb-4">
        <div className="bs-card-header d-flex justify-content-between align-items-center">
          <h4 className="bs-card-header-title">
            Transaction Private Tags &nbsp;
            <span className="badge bg-secondary bg-opacity-10 border border-secondary border-opacity-25 text-dark fw-medium rounded-pill">
              10000 limit
            </span>
          </h4>
          <button className="btn btn-sm btn-primary" onClick={openModal}>
            <i className="bi bi-plus me-1"></i> Add
          </button>
        </div>
        <div className="bs-card-body">
          <div className="p-2">
            <p className="mb-4">
              A private transaction note (up to 100 characters) can be saved and
              is useful for transaction tracking.
            </p>
            <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
              <div className="d-flex align-items-center gap-2">
                <span className="text-muted">&nbsp;0 notes added</span>
              </div>
              <div className="d-flex gap-2">
                <div className="dropdown order-md-2">
                  <button
                    className="btn btn-sm btn-secondary"
                    type="button"
                    id="dropdownSearchFilter"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="bi bi-search fa-fw"></i>
                  </button>
                  <div
                    className="dropdown-menu"
                    aria-labelledby="dropdownSearchFilter"
                    style={{ minWidth: "10rem" }}
                  >
                    <div className="input-group" style={{ minWidth: "22rem" }}>
                      <form
                        action="/mynotes_address"
                        method="get"
                        className="js-focus-state input-group input-group-sm w-100"
                        autoComplete="off"
                      >
                        <input
                          className="form-control py-2"
                          id="q"
                          name="q"
                          type="search"
                          placeholder="Search Address or Tag"
                          maxLength={50}
                        />
                        <button type="submit" className="btn btn-primary">Find</button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <table className="bs-table">
            <thead>
              <tr className="bs-table-row bs-table-header">
                <th className="bs-table-cell">
                  <div className="d-flex bs-cp">Transaction Hash</div>
                </th>
                <th className="bs-table-cell">
                  <div className="d-flex bs-cp">Private Note</div>
                </th>
                <th className="bs-table-cell">
                  <div className="d-flex bs-cp">Actions</div>
                </th>
              </tr>
            </thead>
            <tbody>
              <TransactionPrivateTags key={refreshList} />
            </tbody>
          </table>
        </div>
        <div className="bs-card-footer p-3">
          <BNewPagination
            pagination={pagination}
            totalRecords={50}
            onPagination={setPagination}
          />
        </div>
        <TransactionPrivateTagModal
          show={isModalOpen}
          onClose={closeModal}
          onSuccess={handleTagCreated}
        />
      </div>
    </EmailAccessWrapper>
  );
};

export default TxPrivateTags;
